import React from 'react';
import FileIconDeactivate from 'components/Icons/FileIconDeactivate';
import FileIcon from '../Icons/FileIcon';
import CrossIcon from '../Icons/CrossIcon';

interface Props {
  selectedFile: File[];
  handleClearFile: () => void;
  isDeactivate?: boolean;
}

const LoadedFile: React.FC<Props> = ({ selectedFile, handleClearFile, isDeactivate }) => {
  return (
    <div className="loaded-csv">
      <div className="icon-wrapper">
        {!isDeactivate && <FileIcon />}
        {isDeactivate && <FileIconDeactivate />}
      </div>
      <div className="middle-wrapper">
        <div className="filename">
          <p>{selectedFile[0].name}</p>
        </div>
        <span className="file-type">Arquivo .csv</span>
      </div>
      <div onClick={handleClearFile}>
        <CrossIcon />
      </div>
    </div>
  );
};

export default LoadedFile;
